import { PropsWithChildren } from 'react';
import styles from './StickyFooter.module.scss';

type TProps = {
	backgroundColor?: string;
	hasBorder?: boolean;
	height?: string;
}
type StyleObj = {
	[key: string]: string | number
}

export const StickyFooter = (props: PropsWithChildren<TProps>) => {
	const {
		backgroundColor = 'var(--neutral-00)',
		hasBorder = true,
		height = '70px',
		children
	} = props;

	const setStyles = () => {
		const styles: StyleObj = {}
		if (hasBorder) styles['borderTop'] = '1px solid var(--neutral-03)';
		styles['backgroundColor'] = backgroundColor;
		styles['height'] = height;
		return styles;
	}

	return (
		<footer className={styles.footer} style={setStyles()} data-testid='@Ofload-StickyFooter'>
			{children}
		</footer>
	);
}
